import {
  ReflectionVideosPage,
  ReflectionVideosPageQuery,
  ReflectionVideosPageQueryVariables,
  REFLECTION_VIDEOS_PAGE,
} from '@edwin-group/cj-graphql';
import { useSuspenseQuery } from '@apollo/client';
import { useEffect, useDeferredValue, useLayoutEffect } from 'react';
import { useReflectionVideosStore } from '../store/useSearchStore';
import { useParams } from 'react-router-dom';

export const useReflectionVideos = () => {
  const { keyStageDocumentId } = useParams();
  const filters = useReflectionVideosStore((state) => state.filters);
  const filtersDeferred = useDeferredValue(filters);
  const loading = filters !== filtersDeferred;

  const { data } = useSuspenseQuery<ReflectionVideosPageQuery, ReflectionVideosPageQueryVariables>(
    REFLECTION_VIDEOS_PAGE,
    {
      variables: {
        keysStage: [...(filtersDeferred.keyStages || [])],
      },
    },
  );

  const { data: dataKeyStage } = useSuspenseQuery<ReflectionVideosPageQuery, ReflectionVideosPageQueryVariables>(
    REFLECTION_VIDEOS_PAGE,
    {
      fetchPolicy: 'cache-first',
    },
  );

  useEffect(() => {
    if (data) {
      useReflectionVideosStore.setState({
        page: { page: data.reflectionVideosPage as ReflectionVideosPage },
      });
    }
  }, [data]);

  useEffect(() => {
    if (dataKeyStage) {
      useReflectionVideosStore.setState({
        keysStages: dataKeyStage.reflectionVideosPage?.reflections?.map((reflection) => ({
          documentId: reflection?.keyStage?.documentId || '',
          keyStage: reflection?.keyStage?.keyStage || '',
        })),
      });
    }
  }, [dataKeyStage]);

  useLayoutEffect(() => {
    if (keyStageDocumentId) {
      useReflectionVideosStore.setState({
        filters: { keyStages: [keyStageDocumentId] },
      });
    }
  }, [keyStageDocumentId]);

  return { loading };
};
